module.exports = __webpack_public_path__ + "img/photo-0127.ec392086.jpg";